import React from "react";
import { pushCrashLog } from "../functions/crashLogger";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    pushCrashLog("react_error_boundary", {
      errorName: error?.name,
      errorMessage: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      // Keep UI minimal; mobile wrapper will receive the details via postMessage.
      return (
        <div style={{ padding: 16, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial" }}>
          <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Something went wrong</div>
          <div style={{ opacity: 0.8, lineHeight: 1.4 }}>
            Please reopen the app. If this keeps happening, share the crash log from the mobile console.
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

